import { render, staticRenderFns } from "./JobsearchRecruiteeDetail.vue?vue&type=template&id=28b4361f&scoped=true&"
import script from "./JobsearchRecruiteeDetail.vue?vue&type=script&lang=ts&"
export * from "./JobsearchRecruiteeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobsearchRecruiteeDetail.vue?vue&type=style&index=0&id=28b4361f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4361f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VContainer,VSimpleTable,VSpacer})
